export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  // Next tick: revoking during the click cancels the download.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
